module.exports = __webpack_public_path__ + "static/media/before-you-start.402dfd1d.png";